import React, {ReactNode} from "react"
import AuthMobile from "./AuthMobile";
import AuthCode from "./AuthCode";
import AuthSection from "./AuthSection";


const Auth: React.FC = () => {
    const [mobile, setMobile] = React.useState<string>("")
    const [section, setSection] = React.useState<string>("Mobile")

    const handleSaveMobile = (mobile:string) => {
        setMobile(mobile)
        setSection('Code')
    }


    const sectionComponent:{[key:string]: ReactNode} = {
        'Mobile': <AuthMobile handleSaveMobile={handleSaveMobile} />,
        'Code': <AuthCode handleSection={setSection} mobile={mobile} />
    }

    return (
        <React.Fragment>
            <div className={"min-w-screen bg-background"}>
                <div className={"flex h-screen justify-center items-center"}>
                    <AuthSection isBackBtn={section === "Code"} handleSection={setSection}>
                        {sectionComponent[section]}
                    </AuthSection>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Auth